import * as React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import BaseListingRendererWithPlugins from 'nav/expanded/BaseListingRendererWithPlugins';
import {
  ColumnAccessorKey,
  ColumnConfiguration,
  ListingRendererType,
} from 'nav/expanded/ListingRendererConstants';
import {SortKey} from 'search/SearchConstants';
import {getColumnHeaderFromSortKey} from 'search/SortUtil';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as ScrollableTableConstants from 'ui-library/scrollable/ScrollableTableConstants';
import fuzzydate from 'util/fuzzydate';
import {capitalize} from 'util/NameUtil';
import {BasicEvent} from 'util/Types';
import {worklistTypeDisplayName} from 'worklists/WorklistConstants';

import {WorklistSummaryGraphQL} from '../../../graphql-fragments/worklists/__generated/WorklistSummaryGraphQL';

export default class WorklistSidepanelListingRenderer extends BaseListingRendererWithPlugins<ListingRendererType.WORKLIST> {
  listingRendererType = ListingRendererType.WORKLIST;

  renderIcon(): JSX.Element {
    return <BenchlingIcon className="scrollableTable-cell-icon" icon={ModelTypeConstants.WORKLIST} />;
  }

  getNonPluginColumnConfigurations(
    worklists: Array<WorklistSummaryGraphQL>
  ): Array<ColumnConfiguration<WorklistSummaryGraphQL>> {
    return [
      {
        column: {
          header: getColumnHeaderFromSortKey(SortKey.SORT_NAME_KEY),
          accessorKey: ColumnAccessorKey.NAME,
          isCollapsible: false,
          isSortable: true,
          sortKey: SortKey.SORT_NAME_KEY,
          flexGrow: 1,
        },
        render: (worklist: WorklistSummaryGraphQL) => <div>{worklist.name}</div>,
      },
      {
        column: {
          accessorKey: ColumnAccessorKey.OWNER,
          header: 'Owner',
          flexGrow: 1,
          width: 200,
          isCollapsible: false,
        },
        render: (worklist: WorklistSummaryGraphQL) => <div>{worklist.ownerJson.name}</div>,
      },
      {
        column: {
          header: getColumnHeaderFromSortKey(SortKey.SORT_MODIFIED_AT_KEY),
          accessorKey: ColumnAccessorKey.MODIFIED_AT,
          isCollapsible: false,
          isSortable: true,
          sortKey: SortKey.SORT_MODIFIED_AT_KEY,
          flexGrow: 1,
        },
        render: (worklist: WorklistSummaryGraphQL) => <div>{fuzzydate(worklist.modifiedAt)}</div>,
      },
      {
        column: {
          header: 'Type',
          accessorKey: ColumnAccessorKey.DESCRIPTION,
          isCollapsible: false,
          isSortable: false,
          flexGrow: 1,
        },
        render: (worklist: WorklistSummaryGraphQL) => (
          <div>{capitalize(worklistTypeDisplayName(worklist.itemType))}</div>
        ),
      },
    ];
  }

  getNonPluginRowContentHeight(worklist: WorklistSummaryGraphQL): number {
    return ScrollableTableConstants.TABLE_ROW_BODY_HEIGHT;
  }

  openContextMenu(worklist: WorklistSummaryGraphQL, e: BasicEvent, extras: unknown): void {
    // Not implemented
  }
}
